// extracted by mini-css-extract-plugin
export default {"delete":"PhotoDelete_delete__u1+SD"};